import { Component, OnInit } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { AgenciesService } from 'app/services/agencies/agencies.service';
import { SearchService } from 'app/services/search/search.service';
import Swal from 'sweetalert2';
@Component({
  selector: 'app-cafe-resto-bizerte',
  templateUrl: './cafe-resto-bizerte.component.html',
  styleUrls: ['./cafe-resto-bizerte.component.scss']
})
export class CafeRestoBizerteComponent implements OnInit {

  public coffeBizert: any
  p: Number = 1;
  closeResult = '';
  public agencies: any
  search_name1: any;
  dataSource = new MatTableDataSource();
  public search: string = ''
  constructor(private agenciesService:AgenciesService,private searchService: SearchService) { }

  ngOnInit(): void {
    this.cafeeBizert();

  }
  cafeeBizert() {
this.agenciesService.getList().subscribe((data:any)=>{
  this.coffeBizert = data
  this.agencies = this.coffeBizert.filter((data:any)=>{
return data.region === 'bizerte' && data.phone_number_commercial === 'yes'
  })
})
  }
  performSearch() {
    this.coffeBizert = this.searchService.search(this.coffeBizert, this.search);
  }
  deleteAgencies(agencie, i) {
    Swal.fire({
      title: "Êtes-vous sûr(e) ?",
      text: "Vous ne pourrez pas revenir en arrière !",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Oui, supprimez-le."
    }).then((result) => {
      if (result.isConfirmed) {
        this.agenciesService.deleteItem(agencie.id).subscribe((response: any) => {
          console.log(this.dataSource.data);
          this.coffeBizert.splice(i, 1)

          // If you want to show a success message after the deletion, use another Swal.fire here
          Swal.fire({
            title: "Supprimé!",
            text: "Votre agence a été supprimée.",
            icon: "success"
          });
          // Fetch the updated data after deletion
          // setTimeout(() => {
          //   this.getagencesTunis();
          // }, 500);

        });
      }
    });
  }

}
